import ProfilePage from "../shared/ProfilePage";
import ManagerLayout from "../../layouts/ManagerLayout";

export default function ManagerProfile(){
  return (
    <ProfilePage
      Layout={ManagerLayout}
      roleTitle="Manager"
      editable={false}
    />
  );
}

